<template>
  <div class="container">
    <form class="needs-validation" id="page-form" data-toggle="validator" novalidate>
      <div class="form-group-container">
        <div class="main-list-container">
          <div class="col-12"><h1 class="page-title">Roles</h1></div>

          <div class="col-12 row list-container-row">
            <div class="col-12 pull-left no-gutters list-container-item list-container-item-right">
              <div class="list-container">
                <table class="table table-striped" v-if="this.items.length > 0">
                  <thead class="table-head-blue table-head">
                    <tr>
                      <th scope="col">Name</th>
                      <th scope="col"></th>
                      <th scope="col"></th>
                      <th scope="col"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in this.items" :key="index">
                      <td>
                        {{item.name}}
                        <br />
                      </td>
                      <td></td>
                      <td></td>
                      <td class="small-button">
                        <!-- /product/:id/registrations -->
                        <div class>
                          <router-link
                            :to="'/admin/role/' + item.id"
                            class="btn btn-primary href-btn btn-xs button-right-margin"
                          >edit</router-link>
                          <router-link class="btn btn-danger href-btn btn-xs" to="/">delete</router-link>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="col-12 no-records" v-if="items.length === 0">
                  <div class="row">
                    <h5>Nothing to display!</h5>
                  </div>
                </div>

                <div class="col-12">
                  <div class="row">
                    <!-- <div class="button">
                      <router-link class="btn btn-jezreel-blue href-btn btn-sm" to="/admin/add-product-tag">Add new</router-link>
                    </div>-->
                    <div class="button button-admin-home">
                      <router-link
                        class="btn btn-jezreel-blue href-btn btn-sm"
                        to="/admin"
                      >Admin home</router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
/* eslint-disable */
import { RoleService } from "@/services/RoleService";

export default {
  name: "ListRoles",
  data() {
    return {
      items: []
    };
  },
  methods: {
    async getAll() {
      var response = await RoleService.getAll();
      if (typeof response !== "undefined" && response.success && typeof response.data !== "undefined") {
        this.items = response.data;
      }
    }
  },
  created() {
    this.getAll();
  }
};
</script>

<style scoped>
</style>